//React
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
//React Redux
import { useDispatch, useSelector } from 'react-redux';

//
import { getData, updateAppState } from "../../actions/appstate";

//MUI
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
    Grid, Button, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField,
    InputAdornment, IconButton, TableFooter, Alert
} from '@mui/material';
import {
    CloseSharp as CloseSharpIcon,
    ArrowBackIosNewSharp as ArrowBackIosNewSharpIcon,
    ArrowForwardIosSharp as ArrowForwardIosSharpIcon,
    CheckSharp as CheckSharpIcon,
    GridOn as GridOnIcon
}
    from '@mui/icons-material';
import './grouppricing.scss'
import { Box } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';
//Moments
import moment from 'moment';

//APP's
import theme from '../../theme';
import { styled } from "@mui/material/styles";
import dataService, { fetchDataSimple } from '../../services/data.service';
import { getTileById, getSeriesById } from '../../app/util';
import { calculateRoomDetails, getCorrectValue, getOtbData } from './group_pricing_functions';
import { convertToPercent } from '../DynamicTable/segmentedData';
import { dataFormatMonthlyCard } from '../DailyFlash/functions';

import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // Add the styles for react-date-range
import 'react-date-range/dist/theme/default.css'; // Add the default theme styles
import { dateFormat } from "../../app/util";
import Skeleton from '@mui/material/Skeleton';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { TableVirtuoso } from 'react-virtuoso'

import Header from "../Header";
import { DashboardFooter } from "../layout/dashboard-ui";
import { AtuoLogoutTimer } from '../AutoLogoutTimer';
import { GRACE_TIME, TIME_OUT } from "../../app/config-v4-api";
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TableComponents = {
    Scroller: React.forwardRef((props, ref) => <TableContainer component={Paper} {...props} ref={ref} sx={{ maxHeight: '100%', borderRadius: "8px", boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px" }} size="small" />),
    Table: (props) => <Table {...props} id="GroupTable" stickyHeader size="small" aria-label="a dense table" className='group-pricing-table' />,
    TableHead: React.forwardRef((props, ref) => <TableHead ref={ref} {...props} className='thead' />),
    TableRow: (props) => <TableRow {...props} className='tr-stylex' sx={{ '&:last-child td, &:last-child th': { border: 0 }, maxHeight: "30px" }} />,
    TableBody: React.forwardRef((props, ref) => <TableBody className='tbody-style' {...props} ref={ref} />),
    TableFooter: React.forwardRef((props, ref) => <TableFooter ref={ref} {...props} className='stiky-bottom font-bold' />),
}

function GroupPricing(props) {
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    const { auth, app } = useSelector(state => state);
    let currSymbol = ui_state.currency_symbol;
    const [sendDetails, setSendDetails] = React.useState(false);
    const [value, setValue] = React.useState(0);
    const [arrivalDate, setArrivalDate] = React.useState(moment());
    const [departureDate, setDepartureDate] = React.useState(moment().add(1, 'day'));
    const [arrivalDateTemp, setArrivalDateTemp] = React.useState(moment());
    const [departureDateTemp, setDepartureDateTemp] = React.useState(moment().add(1, 'day'));
    const [groupName, setGroupName] = React.useState(null);
    const [compRooms, setCompRooms] = React.useState(0);
    const [compRoomsPer, setCompRoomsPer] = React.useState(0);
    const [commissionPercent, setCommissionPercent] = React.useState(0);
    // Table row state
    const [runHouse, setRunHouse] = useState([]);
    const tableRowRef = useRef([]);
    const tableTotalRef = useRef({});
    //Table total state    
    const [rohTotal, setRohTotal] = React.useState(0);
    const [pmfb, setPmFb] = React.useState(30);
    const [pmFacility, setPmFacility] = React.useState(75);
    const [pmAudio, setPmAudio] = React.useState(70);
    const [pmOther, setPmOther] = React.useState(45);
    const [fbTotal, setFbTotal] = React.useState(0);

    const handlePmFb = (event) => {
        setPmFb(event.currentTarget.value);
    }
    const handlePmFacility = (event) => {
        setPmFacility(event.currentTarget.value);
    }
    const handlePmAudio = (event) => {
        setPmAudio(event.currentTarget.value);
    }
    const handlePmOther = (event) => {
        setPmOther(event.currentTarget.value);
    }
    const handleCompRooms = (event) => {
        let value = getCorrectValue(event.currentTarget.value);
        setCompRooms(value);
    }
    const handleCompRoomsPer = (event) => {
        let value = getCorrectValue(event.currentTarget.value);
        setCompRoomsPer(value);
    }
    const handleCommissionPercent = (event) => {
        let value = getCorrectValue(event.currentTarget.value);
        setCommissionPercent(value);
    }
    let obj = {
        "loading": false,
        "loaded": false,
        "error": false
    }
    const [compState, setCompState] = React.useState(obj);
    const [open, setOpen] = React.useState(false);
    const handleGroupName = (event) => {
        let grpNameValue = event.currentTarget.value;
        setGroupName(grpNameValue);
        (tableTotalRef.current.runHouseValueTotal > 0 && grpNameValue.length) ? setDisabled(false) : setDisabled(true);
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    //For mailer popover
    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    const handleClickAway = () => {
        setOpen(false);
    };
    const [payload, setPayload] = useState();
    const [disabled, setDisabled] = useState(true);
    const [reset, setReset] = useState(false);
    const [referesh, setReferesh] = useState(false);

    //useEffect(() => {
    // const { selectedDates, finalPayload } = calculateRoomDetails(auth, app_state, dates);
    // setPayload(finalPayload)

    // // send a request to get 365 data 
    // const { data_sources } = getTileById('group');
    // let rangeFromDate = new moment(app_state.as_of_date).startOf('month').format('YYYY-MM-DD');
    // let rangeUntilDate = new moment(rangeFromDate).add(1, "year").endOf('month').format('YYYY-MM-DD');
    // const mainPromises = [];
    // const payLoads = {
    //     OSRYear: {
    //         "method": "GET",
    //         "asOfDate": app_state.as_of_date,
    //         "resourceId": app_state.property_id,
    //         "resourceScope": "property",
    //         "asOfDate": app_state.as_of_date,
    //         "pickupDays": 1,
    //         "rangeFromDate": rangeFromDate,
    //         "rangeUntilDate": rangeUntilDate,
    //         "queryType": "ARI",
    //         "querySubtype": "",
    //         "segmentationType": "market_code",
    //         "segmentFilter": "1",
    //         "type": 1,
    //     },
    // };
    // data_sources.map(activeApi => {
    //     let payload = payLoads[activeApi];
    //     dataService.updateDataCache(activeApi, { payload: payload });
    //     let dataSeries = getSeriesById(activeApi);
    //     let apiCallStarting = getData({
    //         ...app_state, active_api: activeApi,
    //     })();
    //     mainPromises.push(apiCallStarting);
    //     apiCallStarting.then(
    //         (rs) => {
    //             setReferesh(true);
    //         },
    //         (erro) => {

    //         }
    //     )
    // });

    // // end send request to get 365 data 

    // }, [arrivalDate, departureDate, reset, setArrivalDate])
    const [loading, setLoading] = useState(false);
    async function checkOTBData(selectedDates) {
        let start_date = selectedDates[0];
        let end_date = selectedDates.length === 1 ? selectedDates[0] : selectedDates[selectedDates.length - 1];
        // let otbData = (dataService.getSeriesById("OSRYearGroup").data) ? dataService.getSeriesById("OSRYearGroup").data.data : [];
        // let otbEndData = otbData.filter((item, index) => {
        //     return moment(item.index.date).format('YYYY-MM-DD') === moment(end_date).format('YYYY-MM-DD');
        // })
        // if (otbEndData && !otbEndData.length) {
        try {
            setLoading(true);
            let sDate = ''; //moment(otbData[otbData.length - 1].index.date).add(1,'days').format('YYYY-MM-DD');
            const response = await getOtbResponse(start_date, sDate, end_date);
            if (response) {
                return response;
            }
        } catch (error) {
            return error;
        }
        // } else {
        //     return otbEndData;
        // }
    }

    async function getOtbResponse(start_date, sDate, end_date) {
        try {
            console.log(app_state);
            if (moment(sDate) > moment(end_date)) {
                sDate = start_date;
            }

            let property_id = app_state.property_id;
            let sdYear = app_state.workspace_controls.sdYear;
            let pickupDays = app_state.workspace_controls.pickUpDays;
            let asOfDate = app_state.primary_stay_range.as_of_date;
            let rangeFromDate = start_date; //sDate;//app_state.primary_stay_range.date_to;
            let rangeToDate = end_date;
            let osrApi = "rms/properties/otb/" + property_id + "/?includeSellRate=false&segment=false&pickupDays=1&includeSdly=false&asOfDate=" + asOfDate + "&fromDate=" + rangeFromDate + "&toDate=" + rangeToDate;
            const response = await fetchDataSimple({ api: osrApi, request: { method: 'GET' } });
            if (response.status === "success") {
                // let otbData = (dataService.getSeriesById("OSRYearGroup").data) ? dataService.getSeriesById("OSRYearGroup").data.data : [];
                // response.data = [...otbData, ...response.data];
                dataService.updateDataCache("OSRYearGroup", { data: response, loaded: true, loading: false, reqParams: null });
            }
            const data = await response.data;
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    useEffect(() => {
        let { arrivalDate, departureDate } = dates;
        arrivalDate = moment(arrivalDate).format("YYYY-MM-DD");
        departureDate = moment(departureDate).format("YYYY-MM-DD");
        let setDates = [];
        for (var m = moment(arrivalDate); m.isBefore(departureDate); m.add(1, 'days')) {
            let date = moment(m).format("YYYY-MM-DD");
            setDates.push(date);
        }

        checkOTBData(setDates)
            .then((rs) => {
                const { selectedDates, finalPayload } = calculateRoomDetails(auth, app_state, dates);
                setPayload(finalPayload);
                let roomsAvailable = 0;
                let totalRoomsAvailable = 0;
                for (let i = 0; i < selectedDates.length; i++) {
                    let otbData = getOtbData(selectedDates[i]);
                    roomsAvailable = (otbData && otbData.HotelTotal) ? totalCapacity - otbData['HotelTotal']['primary']['Rooms'] : totalCapacity;
                    totalRoomsAvailable = totalRoomsAvailable + roomsAvailable;
                    tableRowRef.current[i] = {
                        date: selectedDates[i],
                        index: i,
                        runHouseValue: 0,
                        rateValue: 0,
                        discountValue: 0,
                        roomsAvailable: roomsAvailable,
                        fbValue: 0,
                        facValue: 0,
                        avValue: 0,
                        otherValue: 0,
                    }
                    let runHouseValueElement = document.getElementsByName(`runHouseValue[${i}]`)[0];
                    if (runHouseValueElement) {
                        runHouseValueElement.value = 0;
                    }
                    let fbValueElement = document.getElementsByName(`fbValue[${i}]`)[0];
                    if (fbValueElement) {
                        fbValueElement.value = 0;
                    }
                    let facValueElement = document.getElementsByName(`facValue[${i}]`)[0];
                    if (facValueElement) {
                        facValueElement.value = 0;
                    }
                    let avValueElement = document.getElementsByName(`avValue[${i}]`)[0];
                    if (avValueElement) {
                        avValueElement.value = 0;
                    }
                    let otherValueElement = document.getElementsByName(`otherValue[${i}]`)[0];
                    if (otherValueElement) {
                        otherValueElement.value = 0;
                    }
                }

                tableTotalRef.current = {
                    roomsAvailableTotal: totalRoomsAvailable,
                    runHouseValueTotal: 0,
                    rateValueTotal: 0,
                    discountValueTotal: 0,
                    fbValueTotal: 0,
                    facValueTotal: 0,
                    avValueTotal: 0,
                    otherValueTotal: 0,
                    finalRowWiseTotalTotal: 0,
                }
                setLoading(false);
            })


    }, [arrivalDate, departureDate])

    const handlePayload = (event, index, type, roomsAvailable = 0) => {
        let datesSelectedArrObj = [];
        tableTotalRef.current.runHouseValueTotal = 0;
        tableTotalRef.current.fbValueTotal = 0;
        tableTotalRef.current.facValueTotal = 0;
        tableTotalRef.current.avValueTotal = 0;
        tableTotalRef.current.otherValueTotal = 0;
        tableTotalRef.current.finalRowWiseTotalTotal = 0;
        switch (type) {
            case 'runHouseValue':
                let { value } = event.currentTarget;
                value = (!value || value < 0 || !Number(value)) ? 0 : value.replace(/^0+/, '');
                if (value > roomsAvailable) {
                    value = roomsAvailable
                }
                event.currentTarget.value = value
                tableRowRef.current[index][type] = value;
                break;
            case 'fbValue':
            case 'facValue':
            case 'avValue':
            case 'otherValue':
                tableRowRef.current[index][type] = event.currentTarget.value;
                break;
            default:
                break;
        }
        selectedDates.forEach((items, i) => {
            let dataObj = {
                "primary": {
                    "rooms": Number(tableRowRef.current[i].runHouseValue)
                },
                "date": items,
                "ancillary": {
                    "food_bev": Number(tableRowRef.current[i].fbValue),
                    "facilities": Number(tableRowRef.current[i].facValue),
                    "audio_visual": Number(tableRowRef.current[i].avValue),
                    "other": Number(tableRowRef.current[i].otherValue)
                }
            }
            datesSelectedArrObj.push(dataObj);
            tableTotalRef.current.runHouseValueTotal += Number(tableRowRef.current[i].runHouseValue)
            tableTotalRef.current.fbValueTotal += Number(tableRowRef.current[i].fbValue)
            tableTotalRef.current.facValueTotal += Number(tableRowRef.current[i].facValue);
            tableTotalRef.current.avValueTotal += Number(tableRowRef.current[i].avValue);
            tableTotalRef.current.otherValueTotal += Number(tableRowRef.current[i].otherValue);
        })
        tableTotalRef.current.finalRowWiseTotalTotal = (
            tableTotalRef.current.fbValueTotal +
            tableTotalRef.current.facValueTotal +
            tableTotalRef.current.avValueTotal +
            tableTotalRef.current.otherValueTotal
        );
        payload['dates'] = datesSelectedArrObj;
        setPayload(payload);

        (tableTotalRef.current.runHouseValueTotal > 0 && groupName) ? setDisabled(false) : setDisabled(true);
        setFbTotal((p) => p + 1);
    }

    /// getting Room details details
    let dates = { arrivalDate, departureDate };
    const { totalNights, totalCapacity, selectedDates, finalPayload } = calculateRoomDetails(auth, app_state, dates);

    /////   submit button functionality ////
    let resObj = {
        "expected_total_revenue": 0,
        "expected_incremental_revenue": 0,
        "arrival_date": "",
        "departure_date": "",
        "recommended_rate": 0,
        "total_revenue_displaced": 0
    };
    const [result, setResult] = useState(resObj)
    const [discount_from_retail, set_discount_from_retail] = useState([]);
    const [recommended_rate, set_recommended_rate] = useState([]);

    const [payloadall, setPayloadAll] = useState([]);
    const [emails, setEmails] = useState(null)
    const handleEmails = (event) => {
        setEmails(event.currentTarget.value);
    }

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function handleDownloadReport() {
        setCompState({ ...compState, "error": false, "errorEmailDownload": true, "errorMsg": "Please wait..., We are generating a quote for you.", "errorType": "info" });
        const { data_popup_api } = getTileById('save_quote');
        let activeApi = data_popup_api.OnSubmit;
        dataService.updateDataCache(activeApi, { payload: payloadall });
        // getData({
        //     ...app_state, active_api: activeApi,
        // })()

        let pid = app_state.property_id;
        let api = 'rms/properties/download-group-quote/' + pid + "/";
        fetchDataSimple({ api, request: payloadall })
            .then((response) => {
                if (response.status === "success") {
                    setCompState({ ...compState, "error": false, "errorEmailDownload": true, "errorMsg": "Quote has been downloaded successfully.", "errorType": "success" });
                    if (response.data.url) {
                        window.location.href = response.data.url;
                    }
                    setTimeout(() => {
                        setCompState({ ...compState, "errorEmailDownload": false, "errorMsg": "" });
                    }, 5000);
                }
            })
            .catch((error) => {
                setCompState({ ...compState, "error": false, "errorEmailDownload": true, "errorMsg": "Please try again !", "errorType": "error" });
                setTimeout(() => {
                    setCompState({ ...compState, "errorEmailDownload": false, "errorMsg": "" });
                }, 5000);
            })
    }

    const handleEmailReport = () => {
        // to check all emails format is correct or not.
        var emailList = emails.split(',');
        var flag = 1;
        for (let i = 0; i < emailList.length; i++) {
            if (validateEmail(emailList[i]) == false) {
                flag = 0;
                break;
            }
        }

        if (flag == 0) {
            setCompState({ ...compState, "error": false, "errorEmailDownload": true, "errorMsg": "Please enter the correct email format.", "errorType": "info" });
            setTimeout(() => {
                setCompState({ ...compState, "error": false });
            }, 3000);
        } else {
            setCompState({ ...compState, "error": false, "errorEmailDownload": true, "errorMsg": "Please wait,sending quote to your email.", "errorType": "info" });
            payloadall['emails'] = emails;
            const { data_popup_api } = getTileById('save_quote');
            let activeApi = data_popup_api.OnSubmit;
            dataService.updateDataCache(activeApi, { payload: payloadall });
            // getData({
            //     ...app_state, active_api: activeApi,
            // })()
            let pid = app_state.property_id;
            let api = 'rms/properties/download-group-quote/' + pid + "/";
            fetchDataSimple({ api, request: payloadall })
                .then((response) => {
                    if (response.status === "success") {
                        setCompState({ ...compState, "error": false, "errorEmailDownload": true, "errorMsg": "Quote has been sent.Thankyou!", "errorType": "success" });
                    }
                    setTimeout(() => {
                        setCompState({ ...compState, "errorEmailDownload": false, "errorMsg": "" });
                    }, 3000);
                })
                .catch((error) => {
                    setCompState({ ...compState, "error": true, "errorEmailDownload": true, "errorMsg": "Something went wrong! Please try again", "errorType": "info" });
                    setTimeout(() => {
                        setCompState({ ...compState, "errorEmailDownload": false, "errorMsg": "" });
                    }, 3000);
                })
            handleClickAway();
        }
    }

    const [showAllContainers, setShowAllContainers] = useState(null);

    const handleSubmit = () => {
        setShowAllContainers(true);
        setCompState({ ...compState, "loaded": false, "loading": true, "error": false })
        let datesArr = [];
        selectedDates.map((items, i) => {
            let dataObj = {
                "primary": {
                    "rooms": Number(tableRowRef.current[i].runHouseValue)
                },
                "date": items,
                "ancillary": {
                    "food_bev": Number(tableRowRef.current[i].fbValue),
                    "facilities": Number(tableRowRef.current[i].facValue),
                    "audio_visual": Number(tableRowRef.current[i].avValue),
                    "other": Number(tableRowRef.current[i].otherValue)
                }
            }
            datesArr.push(dataObj);
        })

        let finalPayload = {
            // "method": "POST",
            "as_of_date": app_state.as_of_date,
            "group_name": groupName,
            "dates": datesArr,
            "overall_request": {
                "profit_percents": {
                    "food_bev": Number(pmfb / 100),
                    "facilities": Number(pmFacility / 100),
                    "audio_visual": Number(pmAudio / 100),
                    "other": Number(pmOther / 100)
                },
                "comp_rooms": {
                    "comp_room_amt": Number(compRooms),
                    "comp_room_per_rooms": Number(compRoomsPer)
                },
                "comission_percent": Number(commissionPercent / 100)
            }
        }
        setPayloadAll(finalPayload);
        const { data_popup_api } = getTileById('group');
        let activeApi = data_popup_api.OnSubmit;
        let pid = app_state.property_id;
        let api = 'rms/properties/group-quote/' + pid + "/";

        fetchDataSimple({ api, request: finalPayload })
            .then((response) => {
                setCompState({ ...compState, "loaded": true, "loading": false, "error": false });
                setSendDetails(true);
                console.log(" response ", response['recommendations'][0]['dates']);
                let datesDiscountArr = [];
                let datesRecRate = [];

                response['recommendations'][0]['dates'].map((item) => {
                    datesDiscountArr.push(convertToPercent(item.discount_from_retail));
                    datesRecRate.push(Math.round(item.recommended_rate));
                })
                set_discount_from_retail([...datesDiscountArr]);
                set_recommended_rate([...datesRecRate]);
                let resObj = {
                    "expected_total_revenue": currSymbol + "" + Math.round(response['recommendations'][0]['overall_recommendation']['expected_total_revenue']),
                    "expected_incremental_revenue": currSymbol + "" + Math.round(response['recommendations'][0]['overall_recommendation']['expected_incremental_revenue']),
                    "arrival_date": response['recommendations'][0]['overall_recommendation']['arrival_date'],
                    "departure_date": response['recommendations'][0]['overall_recommendation']['departure_date'],
                    "recommended_rate": currSymbol + "" + Math.round(response['recommendations'][0]['overall_recommendation']['recommended_rate']),
                    "total_revenue_displaced": currSymbol + "" + Math.round(response['recommendations'][0]['overall_recommendation']['total_revenue_displaced']),
                }
                setResult(resObj);
            })
            .catch((error) => {
                debugger;
                setCompState({ ...compState, "loaded": true, "loading": false, "error": true, "errorMsg": "Something went wrong! Please try again", "errorType": "error" });
                setTimeout(() => {
                    setCompState({ ...compState, "error": false });
                }, 5000);
            });

    }

    // function for reset button 
    const handleReset = () => {
        setShowAllContainers(false);
        setRohTotal(0);

        let resObj = {
            "expected_total_revenue": 0,
            "expected_incremental_revenue": 0,
            "arrival_date": "",
            "departure_date": "",
            "recommended_rate": 0,
            "total_revenue_displaced": 0
        };
        setResult(resObj)
        setArrivalDate(moment());
        setDepartureDate(moment().add(1, 'day'))
        setArrivalDateTemp(moment());
        setDepartureDateTemp(moment().add(1, 'day'))
        setRunHouse([]);
        set_discount_from_retail([]);
        set_recommended_rate([]);
        setCompRooms(0);
        setCompRoomsPer(0);
        setCommissionPercent(0);
        setPmFb(30);
        setPmAudio(70);
        setPmFacility(75);
        setPmOther(45);

        setFbTotal(0);

        setCompState({ "loaded": false, "loading": false, "error": false });
        setEmails("");
        setReset(true);
        setDisabled(true);
        handleClickAway();

        tableRowRef.current = [];
        tableTotalRef.current = {};
    }

    const [dateRangePickerVisiblity, setDateRangePickerVisiblity] = useState(false);
    const toggleDateRangePickerVisiblity = () => {
        if (dateRangePickerVisiblity) {
            setArrivalDate(arrivalDateTemp);
            setDepartureDate(departureDateTemp);
            setDateRangePickerVisiblity(false);
        }
        else {
            setDateRangePickerVisiblity(true);
        }
    };

    const preventTyping = (e) => {
        e.preventDefault();
        return false;
    }

    //Fetch system timezone
    const [timeZone, setTimeZone] = useState('');
    useEffect(() => {
        const getTimeZone = () => {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            setTimeZone(timeZone);
        };
        getTimeZone();
    }, []);

    //handle input copy
    const handleCopy = (index, type, value = 0,) => {
        let alreadyBreak = false;
        let datesSelectedArrObj = [];
        let element = null;

        tableTotalRef.current.runHouseValueTotal = 0;
        tableTotalRef.current.fbValueTotal = 0;
        tableTotalRef.current.facValueTotal = 0;
        tableTotalRef.current.avValueTotal = 0;
        tableTotalRef.current.otherValueTotal = 0;
        tableTotalRef.current.finalRowWiseTotalTotal = 0;

        for (let i = 0; i < selectedDates.length; i++) {
            if (i >= index) {
                switch (type) {
                    case 'runHouseValue':
                        if (tableRowRef.current[i].roomsAvailable < value || alreadyBreak) {
                            alreadyBreak = true
                            break;
                        }
                        tableRowRef.current[i][type] = value;
                        break;
                    case 'fbValue':
                    case 'facValue':
                    case 'avValue':
                    case 'otherValue':
                        tableRowRef.current[i][type] = value;
                    default:
                        break;
                }
                element = document.getElementsByName(`${type}[${i}]`)[0];
                if (element) {
                    element.value = tableRowRef.current[i][type];
                }
            }
            let dataObj = {
                "primary": {
                    "rooms": Number(tableRowRef.current[i].runHouseValue)
                },
                "date": selectedDates[i],
                "ancillary": {
                    "food_bev": Number(tableRowRef.current[i].fbValue),
                    "facilities": Number(tableRowRef.current[i].facValue),
                    "audio_visual": Number(tableRowRef.current[i].avValue),
                    "other": Number(tableRowRef.current[i].otherValue)
                }
            }
            datesSelectedArrObj.push(dataObj);
            tableTotalRef.current.runHouseValueTotal += Number(tableRowRef.current[i].runHouseValue)
            tableTotalRef.current.fbValueTotal += Number(tableRowRef.current[i].fbValue)
            tableTotalRef.current.facValueTotal += Number(tableRowRef.current[i].facValue);
            tableTotalRef.current.avValueTotal += Number(tableRowRef.current[i].avValue);
            tableTotalRef.current.otherValueTotal += Number(tableRowRef.current[i].otherValue);
        }
        tableTotalRef.current.finalRowWiseTotalTotal = (
            tableTotalRef.current.fbValueTotal +
            tableTotalRef.current.facValueTotal +
            tableTotalRef.current.avValueTotal +
            tableTotalRef.current.otherValueTotal
        );
        payload['dates'] = datesSelectedArrObj;
        setPayload(payload);
        (tableTotalRef.current.runHouseValueTotal > 0 && groupName) ? setDisabled(false) : setDisabled(true);
        setFbTotal((p) => p + 1);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
        <AtuoLogoutTimer timeout={TIME_OUT} graceTime={GRACE_TIME}>
            <Header />

            <Box className="group-pricing-wrap page">
                {/* <div className="modal-titlebar">
                    <Box>
                        <div data-id="events">
                            <span className='title-with-icon_xx' style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"></path></svg></span>
                                <span className="text-green">Group Pricing</span>
                            </span>
                        </div>
                    </Box>
                    <Box sx={{ float: 'right' }}>
                        <Button sx={{
                            minWidth: 'auto', width: '22px', height: '22px', p: '7px', position: 'absolute', top: -8, right: -16,
                            mr: '7px', borderRadius: '50%', background: '#000', color: '#FFF', fontSize: '10px', border: '1px solid #EBEBEB', '&:hover': { background: '#000' }
                        }}
                            //onClick={props.handleClose}
                        >
                            <CloseSharpIcon sx={{ fontSize: "1rem" }} />
                        </Button>
                    </Box>
                </div> */}
                <Grid item className='left-part'>
                    <Box sx={showAllContainers ? { display: "flex", justifyContent: "space-between", gap: "12px" } : {}}>
                        <Box flexGrow={1}>
                            <Grid spacing={0} justifyContent="space-between" className="group-top-bar">
                                <Grid item>
                                    <div className='top-bar-item first'>
                                        <label style={{ fontFamily: "SFUI Regular", color: "#606060", fontWeight: "unset", fontSize: "12px" }}>Group Name*</label>
                                        {showAllContainers ? <div className='view-only' > {groupName} </div> :
                                            <TextField tabIndex={1} className='text-field group-name' fullWidth size='small' onChange={handleGroupName} value={groupName} placeholder='Group Name' autoFocus />
                                        }
                                    </div>
                                </Grid>
                                <Grid item>
                                    <div className='top-bar-item'>
                                        <label style={{ fontFamily: "SFUI Regular", color: "#606060", fontWeight: "unset", fontSize: "12px" }}>Selected Date Range</label>
                                        {showAllContainers ? <div className='view-only' > {dateFormat(arrivalDate, "ddd, MMM DD YYYY") + " - " + dateFormat(departureDate, "ddd, MMM DD YYYY")} </div> :
                                            <TextField
                                                tabIndex={1}
                                                onKeyDown={preventTyping}
                                                onClick={toggleDateRangePickerVisiblity}
                                                style={{ cursor: "pointer" }}
                                                fullWidth
                                                className="text-field vijay"
                                                size="small"
                                                value={dateFormat(arrivalDate, "ddd, MMM DD YYYY") + " - " + dateFormat(departureDate, "ddd, MMM DD YYYY")}
                                                InputProps={{
                                                    endAdornment: (
                                                        <IconButton onClick={toggleDateRangePickerVisiblity} edge="end">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"></path></svg>
                                                        </IconButton>
                                                    ),
                                                }}
                                            />
                                        }
                                    </div>
                                </Grid>
                                <Grid item
                                    className={
                                        dateRangePickerVisiblity ? "date-range-picker-container" : "date-range-picker-container-false"
                                    }
                                >
                                    <div className='top-bar-item'>
                                        <DateRangePicker
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            months={2}
                                            direction="horizontal"
                                            ranges={[
                                                {
                                                    startDate: new Date(arrivalDateTemp),
                                                    endDate: new Date(departureDateTemp),
                                                    key: 'selection',
                                                },
                                            ]}
                                            minDate={new Date()} // disabled previous date from current date
                                            onChange={(ranges) => {
                                                // Update arrival and departure dates based on user selection
                                                console.log("arrival", ranges.selection.startDate);
                                                console.log("departure", ranges.selection.endDate);
                                                setArrivalDateTemp(ranges.selection.startDate);
                                                setDepartureDateTemp(ranges.selection.endDate);
                                            }}
                                        />
                                        <Box sx={{ background: "#FFF" }} className="datepicker-done-btn"><Button onClick={toggleDateRangePickerVisiblity}>Done</Button></Box>
                                    </div>
                                </Grid>
                            </Grid>
                            {showAllContainers && <Grid container direction="row" justifyContent="space-between" alignItems="center" className='facts'>
                                <Grid item className="total-counts">
                                    <div className='subheading'>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M240,96a8,8,0,0,1-8,8H216v16a8,8,0,0,1-16,0V104H184a8,8,0,0,1,0-16h16V72a8,8,0,0,1,16,0V88h16A8,8,0,0,1,240,96ZM144,56h8v8a8,8,0,0,0,16,0V56h8a8,8,0,0,0,0-16h-8V32a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Zm72.77,97a8,8,0,0,1,1.43,8A96,96,0,1,1,95.07,37.8a8,8,0,0,1,10.6,9.06A88.07,88.07,0,0,0,209.14,150.33,8,8,0,0,1,216.77,153Zm-19.39,14.88c-1.79.09-3.59.14-5.38.14A104.11,104.11,0,0,1,88,64c0-1.79,0-3.59.14-5.38A80,80,0,1,0,197.38,167.86Z"></path></svg>
                                        </div>
                                        <div>Total Nights</div>
                                    </div>
                                    <div className='heading font-light'>
                                        {totalNights}
                                    </div>
                                </Grid>
                                <Grid item className="total-counts">
                                    <div className='subheading'>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM192,40V216H176V40ZM64,40h96V216H64Zm80,92a12,12,0,1,1-12-12A12,12,0,0,1,144,132Z"></path></svg>
                                        </div>
                                        <div>Total Rooms</div>
                                    </div>
                                    <div className='heading font-light'>
                                        {dataFormatMonthlyCard('Rooms', tableTotalRef.current.runHouseValueTotal, ui_state)}
                                    </div>
                                </Grid>
                                <Grid item className="total-counts">
                                    <div className='subheading'>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35v35.3A56.78,56.78,0,0,0,193.65,184ZM232,93.37A40.81,40.81,0,0,1,210.63,72H232ZM45.37,72A40.81,40.81,0,0,1,24,93.37V72ZM24,162.63A40.81,40.81,0,0,1,45.37,184H24ZM210.63,184A40.81,40.81,0,0,1,232,162.63V184Z"></path></svg>
                                        </div>
                                        <div>Total Revenue</div>
                                    </div>
                                    <div className='heading font-light'>
                                        {(compState.loading) ?
                                            <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                            : dataFormatMonthlyCard('', result.expected_total_revenue, ui_state)
                                        }
                                    </div>
                                </Grid>
                                <Grid item className="total-counts">
                                    <div className='subheading'>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V156.69l50.34-50.35a8,8,0,0,1,11.32,0L128,132.69,180.69,80H160a8,8,0,0,1,0-16h40a8,8,0,0,1,8,8v40a8,8,0,0,1-16,0V91.31l-58.34,58.35a8,8,0,0,1-11.32,0L96,123.31l-56,56V200H224A8,8,0,0,1,232,208Z"></path></svg>
                                        </div>
                                        <div>Incremental Revenue</div>
                                    </div>
                                    <div className='heading font-light'>
                                        {(compState.loading) ?
                                            <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                            : dataFormatMonthlyCard('', result.expected_incremental_revenue, ui_state)
                                        }
                                    </div>
                                </Grid>
                            </Grid>}
                        </Box>
                        {showAllContainers && <Grid item className='right-part'>
                            <div className='recommended-rate'>
                                <div className='heading'>
                                    <div>
                                        <div>Recommended Rate</div>
                                        <span className='subheading'>
                                            Valid until {moment().add(7, "days").format('MMM DD, YYYY')}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <div className='card-svg'>
                                            <svg onClick={handleDownloadReport} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333" viewBox="0 0 256 256"><path d="M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"></path></svg>
                                        </div>
                                        <ClickAwayListener onClickAway={handleClickAway}>
                                            <Box zIndex={1}>
                                                <div className='card-svg' style={open ? { background: "#67C8F5" } : {}}>
                                                    <svg onClick={handleClick} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path></svg>
                                                </div>
                                                {open ? (
                                                    <div className='sent-email'>
                                                        <svg style={{ position: "absolute", top: "-14px", right: "8px" }} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff" viewBox="0 0 256 256"><path d="M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z"></path></svg>
                                                        <div className='message-text'>
                                                            <TextField
                                                                autoFocus
                                                                className='email-sent-textarea'
                                                                fullWidth
                                                                id="input-with-icon-textfield"
                                                                multiline
                                                                placeholder="abc@domain.com, "
                                                                value={emails}
                                                                onChange={handleEmails}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end" cursor="pointer">
                                                                            <svg style={{ cursor: "pointer" }} onClick={handleEmailReport} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M227.32,28.68a16,16,0,0,0-15.66-4.08l-.15,0L19.57,82.84a16,16,0,0,0-2.42,29.84l85.62,40.55,40.55,85.62A15.86,15.86,0,0,0,157.74,248q.69,0,1.38-.06a15.88,15.88,0,0,0,14-11.51l58.2-191.94c0-.05,0-.1,0-.15A16,16,0,0,0,227.32,28.68ZM157.83,231.85l-.05.14L118.42,148.9l47.24-47.25a8,8,0,0,0-11.31-11.31L107.1,137.58,24,98.22l.14,0L216,40Z"></path></svg>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </Box>
                                        </ClickAwayListener>
                                    </div>
                                </div>
                                <Grid sx={{ display: "flex", alignItems: "center" }}>
                                    <Grid className='acceptable'>
                                        <div className='rev-txt'>Optimal Acceptable Rate</div>
                                        <div className='acceptable-rate'>
                                            {(compState.loading) ?
                                                <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                                : dataFormatMonthlyCard('', result.recommended_rate, ui_state)
                                            }
                                        </div>
                                    </Grid>

                                    <div style={{ paddingTop: "6px", paddingBottom: "6px" }}>
                                        <svg width="43" height="159" viewBox="0 0 43 159" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.0264893 79.1529C1.1021 78.8843 2.1626 78.5586 3.20349 78.177C5.1988 77.4212 7.13549 76.5187 8.99756 75.477C10.6929 74.4191 12.1039 72.9628 13.1077 71.2348C14.1114 69.5069 14.6776 67.5597 14.7566 65.563C15.1566 60.8709 15.2405 56.1439 15.2865 51.4309C15.3755 42.3079 15.2866 33.1829 15.3866 24.0599C15.3977 20.3801 15.9709 16.7236 17.0865 13.2169C17.8396 10.6934 19.2077 8.39635 21.068 6.53222C22.9283 4.66809 25.2225 3.29523 27.7445 2.53695C32.4904 1.11718 37.4253 0.430252 42.3785 0.499932C42.4974 0.501723 42.6144 0.529526 42.7213 0.581353C42.8283 0.633181 42.9225 0.707794 42.9976 0.799951C41.7396 1.04595 40.4735 1.25995 39.2245 1.54595C35.4977 2.14244 32.0741 3.95813 29.4896 6.70867C26.9052 9.45922 25.306 12.9893 24.9425 16.7459C24.5373 19.2877 24.3157 21.8553 24.2795 24.4289C24.1985 35.6969 24.2565 46.968 24.1975 58.236C24.249 61.5992 23.7467 64.9479 22.7106 68.148C22.0781 70.0658 21.0474 71.8282 19.6859 73.3197C18.3244 74.8111 16.6629 75.9978 14.8105 76.802C12.9565 77.65 10.9735 78.2179 9.04749 78.9079C8.78349 79.0019 8.5126 79.0749 7.9856 79.2389C8.22456 79.3667 8.46986 79.4821 8.72058 79.5849C10.5026 80.1679 12.3266 80.646 14.0646 81.341C16.5364 82.2565 18.7176 83.8177 20.3813 85.8621C22.0451 87.9066 23.1305 90.3597 23.5245 92.966C24.1124 96.568 24.3552 100.218 24.2495 103.866C24.2545 113.919 24.2375 123.972 24.2595 134.025C24.2012 137.558 24.5648 141.085 25.3425 144.531C26.8855 150.839 30.9086 154.783 36.9976 156.7C38.7836 157.262 40.6475 157.573 42.4745 158C42.6747 158.039 42.8544 158.148 42.9806 158.308C42.8145 158.404 42.632 158.468 42.4425 158.498C37.1765 158.251 31.9275 157.907 26.9355 155.957C24.4419 155.028 22.211 153.508 20.4343 151.527C18.6577 149.545 17.3885 147.163 16.7356 144.583C15.6768 140.578 15.1955 136.443 15.3065 132.302C15.3132 124.394 15.3102 116.486 15.2975 108.579C15.2865 104.612 15.2976 100.641 15.1276 96.6789C15.0316 94.6292 14.7352 92.5939 14.2426 90.602C13.7725 88.6342 12.8359 86.8084 11.5117 85.2789C10.1875 83.7493 8.51469 82.5609 6.63452 81.8139C4.71252 80.9669 2.68156 80.3699 0.700562 79.6579C0.465562 79.5729 0.236488 79.4729 0.000488281 79.3809L0.0264893 79.1529Z" fill="#EBEBEB" />
                                        </svg>
                                    </div>

                                    <Grid sx={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "40px" }} className='rate-facts'>
                                        <Grid className="rev-exp">
                                            <div className='rev-txt'>Total Revenue Expected</div>
                                            <div className='subheading'>
                                                {(compState.loading) ?
                                                    <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                                    : dataFormatMonthlyCard('', result.expected_total_revenue, ui_state)
                                                }
                                            </div>
                                        </Grid>
                                        <Grid className="rev-displayed">
                                            <div className='rev-txt'>Total Revenue Displaced</div>
                                            <div className='subheading'>
                                                {(compState.loading) ?
                                                    <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                                    : dataFormatMonthlyCard('', result.total_revenue_displaced, ui_state)
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <div className='alert-style-container'>
                                    {compState.errorEmailDownload &&
                                        <Alert severity={compState.errorType} className='alert-style'>{compState.errorMsg}</Alert>
                                    }
                                </div>
                            </div>

                            {(sendDetails && sendDetails === 'loader' && <>
                                <div className='arrow-right'></div>
                                <Grid sx={{ pl: 0, pr: 0, pt: 12, background: '#fff', minHeight: "348px" }}>
                                    {/* <Loading showText="Generating the Quote, Please wait..." showLoader="false" leftStyle="10px" /> */}
                                </Grid>
                            </>
                            )

                            }
                        </Grid>}
                    </Box>


                    <Box className={`tabular-data ${showAllContainers ? 'tabular-data-view-only' : ''}`}>
                        <Box mb={1.5} mt={showAllContainers && !compState.error ? 0 : 1.5}>
                            <Tabs value={value} onChange={handleChange} className="tabs-wrap" aria-label="basic tabs example">
                                <Tab className='group-pricing-tabs' label="Room Block*" {...a11yProps(0)} />
                                <Tab className='group-pricing-tabs' label="Group Details" {...a11yProps(1)} />
                                <Tab className='group-pricing-tabs' label="Ancillary Rev" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <TabPanel className="tab-content room-block" value={value} index={0}>
                            <div className='tab-content-root'>
                                <TableVirtuoso 
                                    className='table-virtuoso'
                                    style={{ minHeight: '100px' }}
                                    data={selectedDates}
                                    components={TableComponents}
                                    fixedHeaderContent={() => (
                                        <TableRow>
                                            <TableCell align="center">	</TableCell>
                                            <TableCell align="center">Avail Rooms</TableCell>
                                            <TableCell align="center">Run of House*</TableCell>
                                            <TableCell align="center">Rate</TableCell>
                                            <TableCell align="center">Discount</TableCell>
                                        </TableRow>
                                    )}
                                    itemContent={(i, items) => {
                                        let rateValue = (recommended_rate[i]) ? recommended_rate[i] : 0;
                                        let discountValue = (discount_from_retail[i]) ? discount_from_retail[i] : 0;
                                        let roomsAvailable = (tableRowRef.current[i]) ? Number(tableRowRef.current[i].roomsAvailable) : null;
                                        let runHouseValue = (tableRowRef.current[i]) ? Number(tableRowRef.current[i].runHouseValue) : null;
                                        return (<>
                                            <TableCell className='date-th-style' align="center">{moment(items).format('ddd, MMM DD')}</TableCell>
                                            <TableCell align="center" id={`roomsAvailable_${i}`}>
                                                {(!loading && roomsAvailable)}
                                                {(loading && <CircularProgress color="primary" size={10} />)}

                                            </TableCell>
                                            <TableCell align="center" className='editable' sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", pl: "0px !important", pr: "24px !important" }}>
                                                {showAllContainers ? <div className='ml-15'>{runHouseValue}</div> : <>
                                                    <Button
                                                        onClick={e => handleCopy(i, 'runHouseValue', runHouseValue)}
                                                        className={'copy-btn'}
                                                        tabIndex={1}
                                                    >
                                                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_621_1429)">
                                                                <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                                                                <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_621_1429">
                                                                    <rect width="12" height="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </Button>
                                                    <TextField
                                                        tabIndex={1}
                                                        onChange={e => handlePayload(e, i, 'runHouseValue', roomsAvailable)}
                                                        name={`runHouseValue[${i}]`}
                                                        defaultValue={runHouseValue}
                                                        type="number"
                                                        className='user-entry run_of_house_txt'
                                                        inputProps={{ min: 0, max: roomsAvailable }}
                                                    />
                                                </>}
                                            </TableCell>
                                            <TableCell align="center" sx={{ position: "relative" }}>
                                                {(compState.loading) ?
                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                        <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                                    </Box>
                                                    : currSymbol + "" + rateValue
                                                }
                                            </TableCell>
                                            <TableCell align="center" sx={{ position: "relative" }}>
                                                {(compState.loading) ?
                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                        <Skeleton variant="rounded" width={50} height={15} style={{ backgroundColor: '#B2B2B2' }} />
                                                    </Box>
                                                    : discountValue + "%"
                                                }
                                            </TableCell>
                                        </>)
                                    }}
                                    fixedFooterContent={() => {
                                        let roomsAvailableTotal = tableTotalRef.current.roomsAvailableTotal;
                                        let runHouseValueTotal = tableTotalRef.current.runHouseValueTotal;
                                        let rateValueTotal = 0;
                                        if (showAllContainers && rateValueTotal === 0) {
                                            selectedDates.forEach((date, i) => {
                                                let rateValue = (recommended_rate[i]) ? recommended_rate[i] : 0;
                                                rateValueTotal = parseFloat(rateValueTotal) + parseFloat(rateValue);
                                            })
                                        }
                                        return (
                                            <TableRow className='footer-row'>
                                                <TableCell align="center" className='footer-row date-th-style'>Total</TableCell>
                                                <TableCell align="center" className='footer-row'>
                                                    {/* {roomsAvailableTotal} */}
                                                    {(!loading && roomsAvailableTotal && roomsAvailableTotal.toLocaleString() )}
                                                    {(loading && <CircularProgress color="primary" size={10} />)}
                                                </TableCell>
                                                <TableCell align="center" className='footer-row'>{runHouseValueTotal && runHouseValueTotal.toLocaleString() }</TableCell>
                                                <TableCell align="center" className='footer-row'>
                                                    {currSymbol + (Math.round(rateValueTotal / totalNights)).toLocaleString()}
                                                </TableCell>
                                                <TableCell align="center" className='footer-row'></TableCell>
                                            </TableRow>
                                        )
                                    }}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel className="tab-content " value={value} index={1}>
                            <div className='tab-content-root' style={{padding:"0px 16px"}}>

                                <div className='mb-8'>#Of Comp Rooms</div>
                                <div className='tab2-container'>
                                    <div className='tab2-inputs'>
                                        <label className='label-style'> Per </label>
                                        {showAllContainers ? <div>{compRooms}</div> :
                                            <TextField value={compRooms} onChange={handleCompRooms} type="number" className='tab-two-txt' variant="outlined" />
                                        }
                                    </div>
                                    <div className='tab2-inputs'>
                                        <label className='label-style'>Rooms</label>
                                        {showAllContainers ? <div>{compRoomsPer}</div> :
                                            <TextField value={compRoomsPer} onChange={handleCompRoomsPer} type="number" className='tab-two-txt' label="" variant="outlined" sx={{ width: "70px", textAlign: "center" }} />
                                        }
                                    </div>
                                    <div className='tab2-inputs'>
                                        <label className='label-style-percent'>Commission%</label>
                                        {showAllContainers ? <div>{commissionPercent}</div> :
                                            <TextField value={commissionPercent} onChange={handleCommissionPercent} type="number" className='tab-two-txt' variant="outlined" sx={{ width: "70px", textAlign: "center" }} />
                                        }
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value={value} index={2} className="tab-content ancillary-rev">
                            <div className='tab-content-root'>
                                <TableVirtuoso 
                                    className='table-virtuoso'
                                    data={selectedDates}
                                    components={TableComponents}
                                    fixedHeaderContent={() => (
                                        <>
                                            <TableRow>
                                                <TableCell align="center"></TableCell>
                                                <TableCell align="center">Food & Beverage</TableCell>
                                                <TableCell align="center">Facilities</TableCell>
                                                <TableCell align="center">Audio Visual</TableCell>
                                                <TableCell align="center">Other</TableCell>
                                                <TableCell align="center">Totals</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ minWidth: "116px" }} className='date-th-style'>Profit Margin</TableCell>
                                                <TableCell align="center" className='editable'>
                                                    {showAllContainers ? <div>{`${pmfb}%`} </div> : <>
                                                        <TextField tabIndex={1} type="number" value={pmfb} onChange={handlePmFb} className='user-entry' name='pm_fb' />
                                                        <label className='ml-5'>%</label>
                                                    </>}
                                                </TableCell>
                                                <TableCell align="center" className='editable'>
                                                    {showAllContainers ? <div>{`${pmFacility}%`} </div> : <>
                                                        <TextField tabIndex={1} type="number" value={pmFacility} onChange={handlePmFacility} className='user-entry' name='pm_facility' />
                                                        <label className='ml-5'>%</label>
                                                    </>}
                                                </TableCell>
                                                <TableCell align="center" className='editable'>
                                                    {showAllContainers ? <div>{`${pmAudio}%`} </div> : <>
                                                        <TextField tabIndex={1} type="number" value={pmAudio} onChange={handlePmAudio} className='user-entry' name='pm_audio' />
                                                        <label className='ml-5'>%</label>
                                                    </>}
                                                </TableCell>
                                                <TableCell align="center" className='editable'>
                                                    {showAllContainers ? <div>{`${pmOther}%`} </div> : <>
                                                        <TextField tabIndex={1} type="number" value={pmOther} onChange={handlePmOther} className='user-entry' name='pm_other' />
                                                        <label className='ml-5'>%</label>
                                                    </>}
                                                </TableCell>
                                                <TableCell align="center" className='editable'>

                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )}
                                    itemContent={(i, items) => {
                                        let row = <></>
                                        let fbValue = (tableRowRef.current[i] && tableRowRef.current[i].fbValue) ? Number(tableRowRef.current[i].fbValue) : 0;
                                        let facValue = (tableRowRef.current[i] && tableRowRef.current[i].facValue) ? Number(tableRowRef.current[i].facValue) : 0;
                                        let avValue = (tableRowRef.current[i] && tableRowRef.current[i].avValue) ? Number(tableRowRef.current[i].avValue) : 0;
                                        let otherValue = (tableRowRef.current[i] && tableRowRef.current[i].otherValue)? Number(tableRowRef.current[i].otherValue) : 0;
                                        let finalRowWiseTotal = fbValue + facValue + avValue + otherValue;
                                        row = (<>
                                            <TableCell align="center" className='date-th-style'>{moment(items).format('ddd, MMM DD')}</TableCell>
                                            <TableCell align="center" className='editable' sx={{ pl: "0px !important", pr: "24px !important" }}>
                                                {showAllContainers ? <div className='ml-15'>{fbValue}</div> : <>
                                                    <Button
                                                        onClick={e => handleCopy(i, 'fbValue', fbValue)}
                                                        className={"copy-btn"}
                                                        tabIndex={1}
                                                    >
                                                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_621_1429)">
                                                                <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                                                                <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_621_1429">
                                                                    <rect width="12" height="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </Button>
                                                    <TextField tabIndex={1} onChange={e => handlePayload(e, i, 'fbValue')} name={`fbValue[${i}]`} defaultValue={fbValue} type="number" className='user-entry' inputProps={{ min: 0 }} />
                                                    <label className='ml-15'></label>
                                                </>}
                                            </TableCell>
                                            <TableCell align="center" className='editable' sx={{ pl: "0px !important", pr: "24px !important" }}>
                                                {showAllContainers ? <div className='ml-15'>{facValue}</div> : <>
                                                    <Button
                                                        onClick={e => handleCopy(i, 'facValue', facValue)}
                                                        className={"copy-btn"}
                                                        tabIndex={1}
                                                    >
                                                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_621_1429)">
                                                                <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                                                                <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_621_1429">
                                                                    <rect width="12" height="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </Button>
                                                    <TextField tabIndex={1} onChange={e => handlePayload(e, i, 'facValue')} name={`facValue[${i}]`} defaultValue={facValue} type="number" className='user-entry' inputProps={{ min: 0 }} />
                                                    <label className='ml-15'></label>
                                                </>}
                                            </TableCell>
                                            <TableCell align="center" className='editable' sx={{ pl: "0px !important", pr: "24px !important" }}>
                                                {showAllContainers ? <div className='ml-15'>{avValue}</div> : <>
                                                    <Button
                                                        onClick={e => handleCopy(i, 'avValue', avValue)}
                                                        className={"copy-btn"}
                                                        tabIndex={1}
                                                    >
                                                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_621_1429)">
                                                                <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                                                                <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_621_1429">
                                                                    <rect width="12" height="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </Button>
                                                    <TextField tabIndex={1} onChange={e => handlePayload(e, i, 'avValue')} name={`avValue[${i}]`} defaultValue={avValue} type="number" className='user-entry' inputProps={{ min: 0 }} />
                                                    <label className='ml-15'></label>
                                                </>}
                                            </TableCell>
                                            <TableCell align="center" className='editable' sx={{ pl: "0px !important", pr: "24px !important" }}>
                                                {showAllContainers ? <div className='ml-15'>{otherValue}</div> : <>
                                                    <Button
                                                        onClick={e => handleCopy(i, 'otherValue', otherValue)}
                                                        className={"copy-btn"}
                                                        tabIndex={1}
                                                    >
                                                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_621_1429)">
                                                                <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                                                                <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_621_1429">
                                                                    <rect width="12" height="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </Button>
                                                    <TextField tabIndex={1} onChange={e => handlePayload(e, i, 'otherValue')} name={`otherValue[${i}]`} defaultValue={otherValue} type="number" className='user-entry' inputProps={{ min: 0 }} />
                                                    <label className='ml-15'></label>
                                                </>}
                                            </TableCell>
                                            <TableCell align="center" sx={{ minWidth: "110px" }}>
                                                {(finalRowWiseTotal) ? "$" + finalRowWiseTotal : 0}
                                            </TableCell>
                                        </>)
                                        return row;
                                    }}
                                    fixedFooterContent={() => {
                                        let fbValueTotal = tableTotalRef.current.fbValueTotal;
                                        let facValueTotal = tableTotalRef.current.facValueTotal;
                                        let avValueTotal = tableTotalRef.current.avValueTotal;
                                        let otherValueTotal = tableTotalRef.current.otherValueTotal;
                                        let finalRowWiseTotalTotal = tableTotalRef.current.finalRowWiseTotalTotal;
                                        return (
                                            <TableRow className='footer-row'>
                                                <TableCell align="center" className='footer-row date-th-style'>Total </TableCell>
                                                <TableCell align="center" className='footer-row pr-50'>{currSymbol}{fbValueTotal}</TableCell>
                                                <TableCell align="center" className='footer-row pr-50'>{currSymbol}{facValueTotal}</TableCell>
                                                <TableCell align="center" className='footer-row pr-50'>{currSymbol}{avValueTotal}</TableCell>
                                                <TableCell align="center" className='footer-row pr-50'>{currSymbol}{otherValueTotal}</TableCell>
                                                <TableCell align="center" className='footer-row'>{currSymbol}{finalRowWiseTotalTotal}</TableCell>
                                            </TableRow>
                                        )
                                    }}
                                />
                            </div>
                        </TabPanel>
                    </Box>
                    <div className='submit-button'>
                        {compState.error &&
                            <div className='error-style'>
                                <Alert severity={compState.errorType} className='alert-style'>{compState.errorMsg}</Alert>
                            </div>
                        }
                        {
                            (showAllContainers) ?
                                <>
                                    <Button className="submit" size='medium' onClick={handleReset} variant="outlined">Reset</Button>
                                </>
                                :
                                <>
                                    <Button className={(disabled) ? "disabled" : "submit"} size='medium' disabled={(disabled) ? "disabled" : ""} onClick={handleSubmit} variant="outlined">Submit</Button>
                                </>
                        }
                    </div>
                </Grid>
            </Box >

            <DashboardFooter />
            </AtuoLogoutTimer>
        </LocalizationProvider >
    )
}

export default GroupPricing